import React from "react";
import { useMount } from "react-use";

import { AxiosError } from "axios";
import { show } from "../../../../../notifications/notifications";
import { NotificationsLevel } from "../../../../../lib/enums";
import { HttpError } from "../../../../commons/errors/errors";
import { SCREENSHOT_ERROR_MAP } from "../consts";

type ScreenshotsErrorMessageProps = {
  error?: { error: AxiosError };
  onReanalyze?: () => void;
};

const ScreenshotsErrorMessage: React.FC<ScreenshotsErrorMessageProps> = ({
  error,
  onReanalyze
}) => {
  useMount(() => {
    if (!error) {
      return;
    }
    const errStatus = error.error?.response?.status ?? HttpError.HTTP_50X;
    show({
      level: NotificationsLevel.ERROR,
      message:
        errStatus in SCREENSHOT_ERROR_MAP
          ? SCREENSHOT_ERROR_MAP[errStatus]
          : SCREENSHOT_ERROR_MAP[HttpError.HTTP_50X]
    });
  });

  return (
    <div className="rl-cloud-sandbox__modal_error">
      <h3>No Available Screenshots For This Analysis</h3>
      <p>
        Try{" "}
        {onReanalyze ? (
          <span
            className="rl-cloud-sandbox__reanalyze-link"
            onClick={onReanalyze}
            data-testid="screenshots-error-reanalyze-link"
          >
            reanalyzing
          </span>
        ) : (
          "reanalyzing"
        )}{" "}
        the sample using RL Cloud Sandbox to fetch new screenshots. If sample is
        not stored locally, use Fetch & Analyze option for public samples.
      </p>
    </div>
  );
};

export default ScreenshotsErrorMessage;
